import { Box, Typography, Grid } from "@material-ui/core";
import React, { useState, Fragment } from "react";
import { formatLocaleDate } from "../utils/dateUtils";

export default function RatingTicket({ ticketDetails }) {
  function printDateTime(date) {
    var arr = date.split("-");
    var localeDate = formatLocaleDate(arr[1]);
    var time = arr[2] + ":" + arr[3];
    var dateTime = localeDate + time;
    return dateTime;
  }
  return (
    <Box
      style={{
        maxWidth: "1260px",
        margin: "50px auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        container
        spacing={2}
        className="ratings-ticket-wrapper"
        alignItems="flex-start"
      >
        <Grid
          item
          md={4}
          sm={12}
          container
          alignItems="flex-start"
          className="rating-staff-info"
        >
          <img
            src={
              ticketDetails.staffImageUrl
                ? ticketDetails.staffImageUrl
                : "/images/staff_noimage.png"
            }
          />
          <Typography variant="h6">
            {ticketDetails.staffNickname} <br />
            {ticketDetails.staffAge && ticketDetails.staffAge + " / "}
            {ticketDetails.staffGender && (
              <Fragment>
                {ticketDetails.staffGender == "MALE" ? "男性" : "女性"}
              </Fragment>
            )}
          </Typography>
        </Grid>
        <Grid item md={8}>
          <Grid container className="rating-table">
            <Grid item md={3} sm={3} xs={3}>
              <Typography variant={"h6"}>日時</Typography>
            </Grid>
            <Grid item md={9} sm={9} xs={9}>
              <Typography variant={"h6"}>
                {printDateTime(ticketDetails.reservationTime)}
              </Typography>
            </Grid>
            <Grid item md={3} sm={3} xs={3}>
              <Typography variant={"h6"}>チケット</Typography>
            </Grid>
            <Grid item md={9} sm={9} xs={9}>
              <Typography variant={"h6"}>
                {ticketDetails.productName} | {ticketDetails.ticketNumber}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
